export default {
    daysOfWeek: ["_Sø", "_Ma", "_Ti", "_On", "_To", "_Fr", "_Lø"],
    limit: "__Grense nådd ({{limit}} maks).",
    loading: "__Laster...",
    minLength: "__Min. lengde",
    months: [
        "__Januar",
        "__Februar",
        "__Mars",
        "__April",
        "__Mai",
        "__Juni",
        "__Juli",
        "__August",
        "__September",
        "__Oktober",
        "__November",
        "__Desember"
    ],
    notSelected: "__Ingen valgt",
    required: "__Påkrevd",
    search: "__Søk",
    dateFormat: 'yyyy-MM-dd'
}